import axios from 'axios'
const API_END = "http://18.179.138.213:3001"
export async function get_reference(){
    return await axios.get(API_END + "/reference-home", {headers: {'Content-Type' : 'application.json'}})
}
export async function all_reference(category){
    return await axios.get(API_END + "/reference/" + category, {headers : { 'Content-Type': 'application/json'}});
}